/**
 * Client-side mirror of the backend `@ValidPassword` (shared/validation/ValidPassword.java),
 * which itself mirrors the Keycloak realm policy: 12–100 chars with lower + upper + digit +
 * symbol. Unicode parity matters: the backend uses `\p{javaLowerCase}`-style classes, so an
 * accented letter counts as a LETTER (never as the required symbol). The JS `\p{Ll}`/`\p{Lu}`/
 * `\p{Nd}` classes with the `u` flag match those predicates.
 */
import { z } from 'zod';

export const PASSWORD_POLICY_MESSAGE =
  'Senha deve ter 12+ caracteres com maiúscula, minúscula, número e símbolo';

const PASSWORD_RE = /^(?=.*\p{Ll})(?=.*\p{Lu})(?=.*\p{Nd})(?=.*[^\p{L}\p{Nd}]).*$/u;

export function isValidPassword(v: string): boolean {
  return v.length >= 12 && v.length <= 100 && PASSWORD_RE.test(v);
}

export const passwordSchema = z
  .string()
  .min(12, PASSWORD_POLICY_MESSAGE)
  .max(100, PASSWORD_POLICY_MESSAGE)
  .regex(PASSWORD_RE, PASSWORD_POLICY_MESSAGE);
